// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"uyawV","strongText":"xSTSz","customTable":"nKF2E"};